import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FETCH_ASSETS_URL } from 'appenv';
import { useTranslation } from 'react-i18next';

const ExportIcon = `${FETCH_ASSETS_URL}/assets/export.svg`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1020px;
  margin: auto;
  padding: 16px 0;
`;

const TitleText = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

const ContactCountText = styled.span`
  color: #999998;
  font-size: 16px;
  margin-left: 16px;
`;

const ExportBtn = styled.div`
  border: 2px solid #DBDEE2;
  border-radius: 2px;
  width: 100px;
  font-size: 14px;
  font-weight: bold;
  color: #484848;
  padding: 6px 17px;
  display: flex;
  align-items: center;
  background-color: #FFF;
  cursor: pointer;
  transition: opacity .2s;

  &:hover {
    opacity: .8;
  }
`;

const StyledIcon = styled.img`
  max-width: 16px;
  max-height: 16px;
  margin-right: 4px;
`;

const ContactsHeader = ({ contactCount, exportContactData }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <div>
        <TitleText>
          {t('contact.business_card')}
        </TitleText>
        <ContactCountText>
          {`${contactCount} ${t('contact.business_card_count')}`}
        </ContactCountText>
      </div>
      <ExportBtn onClick={exportContactData}>
        <StyledIcon src={ExportIcon} alt="export" />
        {t('contact.export')}
      </ExportBtn>
    </Container>
  );
};

ContactsHeader.propTypes = {
  contactCount: PropTypes.number.isRequired,
  exportContactData: PropTypes.func.isRequired,
};

export default ContactsHeader;
